/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsavedraft3Inputs */

const en_placewebsavedraft3 = /** @type {(inputs: Placewebsavedraft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as draft`)
};

const de_placewebsavedraft3 = /** @type {(inputs: Placewebsavedraft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Entwurf speichern`)
};

/**
* | output |
* | --- |
* | "Save as draft" |
*
* @param {Placewebsavedraft3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsavedraft3 = /** @type {((inputs?: Placewebsavedraft3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsavedraft3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsavedraft3(inputs)
	return de_placewebsavedraft3(inputs)
});
export { placewebsavedraft3 as "placeWebSaveDraft" }